/**
 * Created by supun on 10/03/18.
 */
export const REDUX_API_GATEWAY_ACTIONS = {
  // saga action
  API_GATEWAY_FETCHING: 'API_GATEWAY_FETCHING',
  API_GATEWAY_FETCH_LATEST: 'API_GATEWAY_FETCH_LATEST',
  API_GATEWAY_FETCHING_SUCCESS: 'API_GATEWAY_FETCHING_SUCCESS',
  API_GATEWAY_FETCHING_FAILURE: 'API_GATEWAY_FETCHING_FAILURE',
  // pets action
  GET_USER_SUCCESS: 'GET_USER_SUCCESS',
  GET_USER_FAILE: 'GET_USER_FAILE',
  GET_REPORT_LINK_SUCCESS: 'GET_REPORT_LINK_SUCCESS',
  GET_REPORT_LINK_FAIL: 'GET_REPORT_LINK_FAIL',

  UPDATE_REPORT_SUCCESS: 'UPDATE_REPORT_SUCCESS',
  UPDATE_REPORT_FAIL: 'UPDATE_REPORT_FAIL',

  GET_EDITING_REPORT_SUCCESS: 'GET_EDITING_REPORT_SUCCESS',
  GET_EDITING_REPORT_FAIL: 'GET_EDITING_REPORT_FAIL',

  GET_REPORTS_DATA_SUCCESS: 'GET_REPORTS_DATA_SUCCESS',
  GET_REPORTS_DATA_FAIL: 'GET_REPORTS_DATA_FAIL',

  GET_NEXT_REPORT_SUCCESS: 'GET_NEXT_REPORT_SUCCESS',
  GET_NEXT_REPORT_FAIL: 'GET_NEXT_REPORT_FAIL',
};

export const ACTION_KEY = {
  GET_USER: 'GET_USER',
  SEARCH_REPORT: 'SEARCH_REPORT',
  UPDATE_REPORT: 'UPDATE_REPORT',
  GET_EDITING_REPORT: 'GET_EDITING_REPORT',
  GET_REPORTS_DATA: 'GET_REPORTS_DATA',
  GET_NEXT_REPORT: 'GET_NEXT_REPORT',
};
export const ENDPOINTS = {
  REST_API: 'RestApi',
  OCR_API: 'OcrApi',
};
export const API_ROUTE = {
  // user end points
  USER: '/user',
  SEARCH_REPORT: '/api/report?reportId=/:reportId',
  GET_EDITING_REPORT:
    '/api/report/edit?batchId=/:batchId&reviewLevel=/:reviewLevel',
  UPDATE_REPORT: '/api/report/edit',
  GET_REPORTS_DATA: '/api/list/csv',
  GET_NEXT_REPORT: '/api/report/prefixscan',
};
export const ACTION_ATTR = {
  PAYLOAD: 'payload',
  DATA: 'data',
};



// WEBPACK FOOTER //
// ./src/constants/apiGateWayConstant.js